import React from 'react';

import GroupsModal from '../../../containers/authorization/groups/GroupsModal';
import GroupsTablePane from '../../../containers/authorization/groups/GroupsTablePane';

const GroupsTabPane = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
      <GroupsTablePane />
      <GroupsModal />
    </div>
  );
};

export default GroupsTabPane;
